/**
 * `common` namespace — English canonical source.
 *
 * Shared, cross-surface strings: generic actions (save/cancel/retry), transient
 * status, and neutral empty/error copy. Every other namespace SHOULD reuse these
 * (`t('common.retry')`) instead of re-declaring a synonym, so a wording change
 * lands in one place. Keys are dot-free and camelCase; values are the canonical
 * English text. `ko/common.ts` mirrors this shape (a missing key is a type error).
 */
export const common = {
  // ── transient status ──
  loading: "Loading",
  saving: "Saving",
  saved: "Saved",
  syncing: "Syncing",

  // ── generic actions ──
  save: "Save",
  cancel: "Cancel",
  retry: "Retry",
  tryAgain: "Try again.",
  confirm: "Confirm",
  close: "Close",
  remove: "Remove",
  delete: "Delete",
  edit: "Edit",
  refresh: "Refresh",
  sync: "Sync",
  back: "Back",
  done: "Done",

  // ── generic status / feedback ──
  errorGeneric: "Something went wrong.",
  saveFailed: "Could not save. Try again.",
  loadFailed: "Could not load. Try again.",
  emptyGeneric: "Nothing here yet.",
  requiredField: "Required.",

  // ── shared interpolated copy ──
  selectedCount: "{count} selected",
} as const;

export type CommonKey = keyof typeof common;
